import React, {useState, useEffect} from 'react';
import AddCash from '../AddCash/AddCash';
import AddCashV1 from '../AddCashV1/AddCashV1';
import {getCookie} from './../../../../utils/getCookie';

const AddCashWrapper = props => {
  const {
    isLoyal,
    addBalanceToWallet,
    openPayment,
    closePayments,
    neftDetailsCaller,
    blacklistBlock,
    earnMore,
    earnMoreData,
    is_sub_user,
  } = props;

  const [showNefyPay, setShowNeftPay] = useState(false);
  const [showWalletNew, setShowWalletNew] = useState(false);

  const showNeft = getCookie('mp_neft');
  const showNewWallet = getCookie('mp_new_wallet');

  useEffect(() => {
    if (showNeft === '1') {
      setShowNeftPay(true);
    }
  }, [showNeft]);

  useEffect(() => {
    if (showNewWallet === '1') {
      setShowWalletNew(true);
    }
  }, [showNewWallet]);

  return (
    <>
      {isLoyal && showWalletNew ? (
        <AddCashV1
          addBalanceToWallet={addBalanceToWallet}
          openPayment={openPayment}
          neftDetailsCaller={neftDetailsCaller}
          earnMore={earnMore}
          earnMoreData={earnMoreData}
          is_sub_user={is_sub_user}
        />
      ) : (
        <AddCash
          addBalanceToWallet={addBalanceToWallet}
          openPayment={openPayment}
          closePayments={closePayments}
          neftDetailsCaller={neftDetailsCaller}
          blacklistBlock={blacklistBlock}
          showNefyPay={showNefyPay}
          showWalletNew={showWalletNew}
          is_sub_user={is_sub_user}
        />
      )}
    </>
  );
};

export default AddCashWrapper;
